exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ra-field label {\n  font-weight: 900; }\n\n.field-label {\n  color: rgba(0, 0, 0, 0.54);\n  padding: 0;\n  font-size: 12px; }\n\n.field-value {\n  font-size: 14px;\n  margin-top: 8px; }\n", ""]);

